import isApiError from "@insite/client-framework/Common/isApiError";
import { get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    uri?: string;
    soaOrderStatusSummary?: {
        count?: number;
        isPrintPriceEnabled?: boolean;
    };
    asnOrderStatusSummary?: {
        count?: number;
    };
    podOrderStatusSummary?: {
        count?: number;
        frequency?: string;
    };
    parentId?: string;
    totalSites?: number;
    isParentSite?: boolean;
    properties?: {
        [key: string]: string;
    };
    companyName: string;
    isFreshAccount: boolean;
}

export type GetPhoneApiResultModel = PhoneModel [];

export interface PhoneModel {
    email: string;
    phone: string;
}


const url = "/api/v1/orderStatusDashboard";

export async function getSubscriptionsData(customerId?: string) {
    const queryParams = customerId ? `?customerId=${customerId}` : "";

    try {
        const result = await get<ApiResultModel>(`${url}${queryParams}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}

export async function getPhoneNumberService(emailId?: string) {
    try {
        const result = await get<GetPhoneApiResultModel>(`/api/v1/osnEmailSubscription?emails=${emailId}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}
